// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--21e6d";
export var content = "Layout-module--content--8dfc5";
export var standardPadding = "Layout-module--standardPadding--e37a0";